// Angular Imports
import { Component, OnInit, computed, inject, signal } from '@angular/core'
import { CommonModule } from '@angular/common'
import { environment } from '@environment'
// Shared Imports
import { EEnvironment } from '@shared/models'
import { EnvironmentStore } from '@shared/store'

@Component({
	selector: 'app-environment-decorator',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './environment-decorator.component.html',
	styleUrls: ['./environment-decorator.component.scss'],
})
export class EnvironmentDecoratorComponent implements OnInit {
	readonly #environmentStore = inject(EnvironmentStore)
	readonly EEnvironment = EEnvironment

	environmentLabel: EEnvironment = EEnvironment.dev
	hidden = signal<boolean>(false)
	version = computed(() => this.#environmentStore.version())

	ngOnInit(): void {
		// Set current environment
		environment.environment === EEnvironment.local && (this.environmentLabel = EEnvironment.local)
		environment.environment === EEnvironment.dev && (this.environmentLabel = EEnvironment.dev)
		environment.environment === EEnvironment.test && (this.environmentLabel = EEnvironment.test)
		environment.environment === EEnvironment.prod && (this.environmentLabel = EEnvironment.prod)
	}

	onHiddenDecoratorFor10Seg() {
		this.hidden.set(true)
		const _timeoutId: number = window.setTimeout(() => {
			this.hidden.set(false)
		}, 10000)
	}
}
